import React from 'react';
import AddProjectPopup from '@features/project/project-creation/AddProjectPopup';
import FilesUploader from '@features/project/project-creation/FilesUploader/FilesUploader';
import DeleteProjectModal from '@features/projects/DeleteProjectModal/DeleteProjectModal';
import { ProjectActionsPopupType } from '@utils/types';

type Props = {
    projectToDeleteId?: string;
    type: ProjectActionsPopupType | null;
    setPopupType: (type: ProjectActionsPopupType | null) => void;
    onProjectCreation: (projectId: string) => void;
};

const ProjectActionsPopup = ({
    projectToDeleteId,
    type,
    setPopupType,
    onProjectCreation,
}: Props) => {
    switch (type) {
        case 'model':
            return (
                <AddProjectPopup setVisible={setPopupType} onProjectCreation={onProjectCreation} />
            );
        case 'creation':
            return <FilesUploader setVisible={setPopupType} />;
        case 'delete':
            return <DeleteProjectModal projectId={projectToDeleteId} setVisible={setPopupType} />;
        default:
            return null;
    }
};

export default ProjectActionsPopup;
